var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5968",
    "data-name": "Group 5968",
    transform: "translate(10413 -5964)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_102",
    "data-name": "Ellipse 102",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(-10413 5964)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "hourglass",
    transform: "translate(-10405 5969)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_836",
    "data-name": "Group 836"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_894",
    "data-name": "Path 894",
    d: "M71.428,7.672a8.307,8.307,0,0,0,3.179-6.537h1.147V0H61V1.135h1.147a8.307,8.307,0,0,0,3.179,6.537c.861.785,1.349,1.266,1.349,2.012s-.487,1.227-1.349,2.012a8.307,8.307,0,0,0-3.179,6.537H61v1.135H75.753V18.234H74.607A8.307,8.307,0,0,0,71.428,11.7c-.861-.785-1.349-1.266-1.349-2.012S70.566,8.457,71.428,7.672Zm-3.619,6.266a2.869,2.869,0,0,0-.517.159l-3.476,1.438a7.742,7.742,0,0,1,2.274-3c.884-.806,1.719-1.567,1.719-2.851Zm2.854-1.4a7.743,7.743,0,0,1,2.274,3L69.462,14.1a2.87,2.87,0,0,0-.517-.159V9.684C68.944,10.968,69.779,11.729,70.663,12.535ZM63.8,3.783a8.408,8.408,0,0,1-.513-2.648H73.471a8.407,8.407,0,0,1-.513,2.648Z",
    transform: "translate(-61)",
    fill: "#3f2566"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullTime);
export default __webpack_public_path__ + "static/media/full_time.c2c0833fcbc6b8dcb4ebe4e9957484d9.svg";
export { ForwardRef as ReactComponent };